import { routes } from "../../constants";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import useLocalStorage from "../../hooks/useLocalStorage";
import { appConfig } from "../../constants/config/appConfig";

const RequireAuth = ({allowedRoles}) => {
  const location = useLocation();
  
  /* local storage dependencies */
  const {userSession} = useLocalStorage(appConfig.SESSION_USER_INFO)
  /* local storage dependencies */

  const isAuthorized = allowedRoles?.includes(userSession?.userRole);

  return isAuthorized ? (
    <Outlet/>
  ) : (
    <Navigate to={routes.SIGN_IN} state={{ from: location }} replace />
  );
};

export default RequireAuth;
